import classNames from 'classnames';
import React from 'react';
import Filter from '../filter/filter';

import {
  FilterWrapper as Props,
  BreakAtElements,
} from './filter-wrapper.types';

const FilterWrapper: React.FunctionComponent<Props> = ({ filters }) => (
  <div
    className={classNames('filter-wrapper', {
      [`filter-wrapper--medium`]: filters.length <= BreakAtElements.medium,
      [`filter-wrapper--wide`]: filters.length >= BreakAtElements.wide,
      [`filter-wrapper--single`]: filters.length === 1,
    })}
  >
    {filters.map((filter, i) => (
      <Filter {...filter} key={i} />
    ))}
  </div>
);

export default FilterWrapper;
